const isNative = () => window && window.ReactNativeWebView;

export default isNative;
